import PublicApiService from './PublicApiService';

import apiService from '../ApiService';

export default new PublicApiService(apiService);
